import { render, staticRenderFns } from "./CockatooNationalPark.vue?vue&type=template&id=70d94416&"
import script from "./CockatooNationalPark.vue?vue&type=script&lang=js&"
export * from "./CockatooNationalPark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports